import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import NewProjectForm from "./NewProjectForm/NewProjectForm";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import ProjectsTable from "./ProjectsTable/ProjectsTable";
import { read, store } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import {SELECTED_PROJECT, SHOW_PROJECTS, UNIT_INFO} from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import ProjectBox from "./ProjectBox";
import ProjectOptions from "./ProjectOptions";

export default function ProjectList() {
  const [projectShow, setProjectShow] = useState(0);
  const dispatch = useDispatch();
  const { selectedProject, onClickShowProject } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    onClickShowProject: state.project.onClickShowProject
  }));
  const onSelect = (row) => {
    dispatch({
      type: SELECTED_PROJECT,
      selectedProject: row,
    });
    store("project", row);
    store("unitId", undefined);
    dispatch({
      type: UNIT_INFO,
      unitInfo: null,
    });
    setProjectShow(1);
    dispatch({
      type: SHOW_PROJECTS,
      value: false,
    });
  };

  useEffect(() => {
    if(selectedProject && selectedProject !== 'undefined') {
      setProjectShow(1);
    } else {
      setProjectShow(2);
    }
  },[selectedProject])

  useEffect(() => {
    if(onClickShowProject) {
      setProjectShow(2);
    }
  },[onClickShowProject])

  return (
    <>
      {
        projectShow === 2 &&
        <div className="page-top-title-button">
          <PageTitle title={<Translator id="projectsListMenu" />} />
          <div className="top-buttons">
            <NewProjectForm />
          </div>
        </div>
      }
      <ProjectOptions projectList={projectShow} />
      {
        projectShow === 2 &&
        <>
          <ProjectBox ALoad={((read("StypeU") === "1" || read("StypeU") === "5") && read("UserC") === "-")} />
          <MuiPaper>
            <ProjectsTable onSelect={onSelect} />
          </MuiPaper>
        </>
      }
    </>
  );
}
